import type { AddressTagType } from 'application/components/AddressTagFilter/types';

export type PointWithAddressTags = {
  address?: string | null;
  tags?: AddressTagType[] | null;
};

export const normalizeSearchValue = (value?: string | null) => value?.trim().toLowerCase() || '';

export const getUniqueAddressTags = <T extends PointWithAddressTags>(points: T[]): AddressTagType[] => {
  const tagsById = new Map<string, AddressTagType>();

  points.forEach((point) => {
    point.tags?.forEach((tag) => {
      if (!tagsById.has(tag.id)) {
        tagsById.set(tag.id, tag);
      }
    });
  });

  return Array.from(tagsById.values());
};

export const filterPointsByAddressAndTags = <T extends PointWithAddressTags>(
  points: T[],
  search: string,
  selectedTagIds: string[],
  isExactSearch: boolean
) => {
  const normalizedSearch = normalizeSearchValue(search);

  return points.filter((point) => {
    const isMatchedByAddress = !normalizedSearch || normalizeSearchValue(point.address).includes(normalizedSearch);

    if (!isMatchedByAddress || selectedTagIds.length === 0) {
      return isMatchedByAddress;
    }

    const pointTagIds = new Set(point.tags?.map((tag) => tag.id));

    return isExactSearch
      ? selectedTagIds.every((tagId) => pointTagIds.has(tagId))
      : selectedTagIds.some((tagId) => pointTagIds.has(tagId));
  });
};
